import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { get } from '../utils/storageUtils';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const userToken = get('local', 'userToken');
  return (
    <Route
      {...rest}
      render={(props) =>
        userToken ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export default ProtectedRoute;